module.exports = __webpack_public_path__ + "img/14_13.e227a04f.png";